import { render, staticRenderFns } from "./RedDetailHeaderBar.vue?vue&type=template&id=ecf7b18a&scoped=true"
import script from "./RedDetailHeaderBar.vue?vue&type=script&lang=js"
export * from "./RedDetailHeaderBar.vue?vue&type=script&lang=js"
import style0 from "./RedDetailHeaderBar.vue?vue&type=style&index=0&id=ecf7b18a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ecf7b18a",
  null
  
)

export default component.exports